import { POSITIONS as FLYOUT_POSITIONS } from "../flyout/constants";
import type { Side } from "../flyout/types";

export const POSITIONS: Record<string, Side> = {
  BOTTOM: FLYOUT_POSITIONS.BOTTOM,
  TOP: FLYOUT_POSITIONS.TOP,
} as const;

export const ALIGNS = {
  RIGHT: "right",
  LEFT: "left",
} as const;

export const TRANSITION_TIMEOUT = 300;
